<template>
  <sui-grid :columns="1" class="grid-posts-home" centered>
    <sui-grid-row v-if="items.length > 0">
      <sui-grid-column>
        <sui-grid
          v-for="(row, index) in items"
          :key="index"
          :columns="row.items.length"
          class="grid-posts-home"
          centered
        >
          <sui-grid-row>
            <sui-grid-column
              v-for="(item, i) in row.items"
              :key="`${item.slug}-${i}`"
              class="grid-posts-home__item"
              :computer="Math.floor(item.weight) === 5 ? null : Math.floor(item.weight)"
              :mobile="Math.floor(item.weight) === 5 ? null : 16"
            >
              <grid-item
                @click.native="setPosition"
                :image="item.image"
                :title="item.title"
                :client="item.client"
                :description="item.description"
                :year="item.year"
                :country="item.regional_name"
                :theme="getTheme(item)"
                :link="`/${item.type === 'work' ? 'works' : 'news'}/${$i18n.locale}/${item.slug}`"
              />
            </sui-grid-column>
          </sui-grid-row>
        </sui-grid>
      </sui-grid-column>
    </sui-grid-row>
  </sui-grid>
</template>

<script>
export default {
  name: "grid-posts-home",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getTheme(item) {
      if (item.weight === 16) {
        return "full";
      }

      if (item.type === "news") {
        return "text-only";
      }

      return "default";
    },

    setPosition() {
      this.$store.dispatch("setWindowPosition", $(window).scrollTop());
    },
  },
};
</script>

<style lang="scss">
.grid-posts-home {
  max-width: 1600px;
  margin: 0 auto !important;
  padding: 30px;
  display: flex;
  justify-content: space-between;

  .row {
    justify-content: space-between !important;
    margin: 0 0 100px 0 !important;
  }

  &--full {
    margin-top: 55px !important;
  }

  &__item {
    a {
      color: black;
      height: 100%;
    }
  }
}

@media (max-width: 1000px) {
  .grid-posts-home {
    .row {
      padding: 0 !important;
      margin: 0 !important;
    }

    &--full {
      margin-top: 0 !important;
    }

    &__item {
      &.column {
        width: 100% !important;
        padding: 0 !important;
      }
    }
  }
}
</style>
